import React, { useEffect, useState, useContext, useRef } from 'react';
import { Link } from "react-router-dom";
import Layout from '../../../parts/Layout';
import { httpRequest } from '../../../../services/httpService';
import helpers from '../../../../services/helpers';
import initTreeView from '../../../../services/initTreeView';
import ProfileContext from '../../../../services/profileContext';
import { getApiData } from '../../../../services/apiService';
import LayoutCashFlow from './../parts/LayoutCashFlow';
import CashFlowCategoryForm from './CashFlowCategoryForm';
import { httpAuthHeaders } from '../../../../services/httpService';

import Swal from 'sweetalert2';
import Loader from '../../../parts/Loader';
import Dropdown from 'react-bootstrap/Dropdown'
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { InputText } from 'primereact/inputtext';
import { SelectButton } from 'primereact/selectbutton';
import { Button } from 'primereact/button';
import { Menu } from 'primereact/menu';
import { Toast } from 'primereact/toast';
import {
    FaAngleDown,
    FaPrint,
    FaTimesCircle,
    FaRegFileExcel,
    FaTrashAlt 
} from "react-icons/fa";
import { BsThreeDotsVertical } from "react-icons/bs";
 
export default function CashFlowCategoryList ({viewer = 'admin', menu = 'cashflow-categories', page_title = "Categories"}){
    const {
        account
    } = useContext(ProfileContext);
    const default_currency = helpers.getSettingValue(account?.settings, 'default_currency', '₱');
    const menuRight = useRef(null);
    const toast = useRef(null);
    const [record_data, setRecordData] = useState([]);
    const [loading, setLoading] = useState(1);
    const [search_key, setSearchKey] = useState('');
    const [reference_id, setReferenceID] = useState('');
    const [show_modal, setShowModal] = useState(0);

    const [data_table, setDataTable] = useState([]);
    const [selected_items, setSelectedItems] = useState([]);
    const [selected_all, setSelectAll] = useState(false);
    const [datatable_state, setDataTableState] = useState({
        first: 0,
        rows: 10,
        page: 0,
        sortField: null,
        sortOrder: null
    });
    const [initial_loaded, setDataLoaded] = useState(false);
    const effectRan = useRef(false);
    const [category_type, setCategoryType] = useState('expense');
    const [menuAlignment, setMenuAlignment] = useState('right'); // Default desktop to right
        
    const action_items = [
            {
                label: 'Export',
                icon: <FaRegFileExcel className='mr-2 text-dark'/>,
                command: () => {
                    exportReport()
                    //window.open(`/ship-booking/bookings/${booking_id}/print-view`, "_blank", "noopener,noreferrer");
                }
            },
            {
                label: 'Bulk Delete',
                icon: <FaTrashAlt className='mr-2 text-danger'/>,
                command: () => {
                    //handleCancel()
                    triggerAction(selected_items)
                },
                visible: selected_items.length ? true : false,
                disabled: !helpers.checkPermissions(['superAdmin', 'cashFlowCategoryDelete'], account?.permissions),
            },
    ];

    useEffect(() => {
        initTreeView()

        const handleResize = () => {
        // 768px is the standard mobile breakpoint (md)
        if (window.innerWidth < 768) {
            setMenuAlignment('left');  // Snaps left edge of menu to left edge of button
        } else {
            setMenuAlignment('right'); // Snaps right edge of menu to right edge of button
        }
        };

        // Run once on load
        handleResize();

        // Listen for screen adjustments
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    useEffect(() => {
        displayDataTable(record_data)
    }, [datatable_state.sortOrder]);

    useEffect(() => {
        displayDataTable(record_data)
    }, [
        selected_items, 
        selected_all
    ]);

    useEffect(() => {
        fetchDataList()
    }, [
        datatable_state,
        category_type
    ]);

    async function fetchDataList(condition = {
        "page": '',
        "search": '',
        "per_page": ''
    }){
        const page = datatable_state.page
        const per_page = datatable_state.rows
        const search = search_key
        let filter = `?paginate=1&`

        if(page){
            filter += 'page='+page+'&'
        }
        if(per_page){
            filter += 'per_page='+per_page+'&'
        }
        if(search){
            filter += 'search='+search+'&'
        }
        if(category_type && category_type !== 'all'){
            filter += 'type='+category_type+'&'
        }

        filter = filter.slice(0, -1)

        setLoading(1)

        let endpoint = helpers.createUrl(`V1/cashflow/categories${filter}`)
        const res = await getApiData(endpoint, false)

        if(res.status === 'error'){
            toast.current.show({severity:'error', summary: 'Error', detail: res.message, life: 20000});
            setLoading(0)
        }
        else{
            setRecordData(res)
            setLoading(0)
            displayDataTable(res)
        }
    }

    function exportReport(){
        const page = datatable_state.page
        const per_page = datatable_state.rows
        const search = search_key
        let filter = `?paginate=1&export=excel&`

        if(page){
            filter += 'page='+page+'&'
        }
        if(per_page){
            filter += 'per_page='+per_page+'&'
        }
        if(search){
            filter += 'search='+search+'&'
        }
        if(category_type && category_type !== 'all'){
            filter += 'type='+category_type+'&'
        }

        filter = filter.slice(0, -1)

        //let filter = '?store_id='+helpers.getStoreID()+'&export=excel&'

        setLoading(1)
        const today = new Date();
        const month = today.getMonth() + 1;
        const date = today.getFullYear() + '-' + month + '-' + today.getDate() + '_' +  today.getHours() + '-' + today.getMinutes() + '-' + today.getSeconds();
        const file_name = 'cashflow-categories-data-export-' + date + '.xlsx';


        let endpoint = helpers.createUrl(`V1/cashflow/categories/export${filter}`)
        
        fetch(endpoint, {
            method: 'GET',
            headers: httpAuthHeaders(),
        })
        .then((res) => {
          if(res.ok) {
            return res.blob();
          }
          
          const json = res.json();
          const status_code = res.status;
  
          if (!res.ok) {
              let errorCode = json.error_code ? json.error_code : 'unknown';
              let message = json.message ? json.message : (res.statusText ? res.statusText : 'Request failed');
              let data = json.error ? json.error: '';
              let status = json.status ? json.status: '';
              let error = { data: data, message: message, error_code: errorCode, status_code: status_code, status: status };
  
              if (status_code === 422) error = { ...error, ...json };
  
              return Promise.reject(error);
          }
        })
        .then(blob => {
            toast.current.show({severity:'success', summary: 'Completed', detail: "Export successfully completed. Please check your downloads.", life: 20000});

            var url = window.URL.createObjectURL(blob);
            const a = document.createElement("a");
            document.body.appendChild(a);
            a.setAttribute("style", "display: none");
            a.setAttribute("href", url);
            a.download = file_name;
            a.click();
            window.URL.revokeObjectURL(url);
            a.parentNode.removeChild(a);
            setLoading(0);
        })
        .catch(err => {
            //Swal.fire("Error", "Export failed", "error");
            toast.current.show({severity:'error', summary: 'Error', detail: "Export failed", life: 20000});
            setLoading(0);
        });
    }
    
    function search(e){
        let { value } = e.target;
        setSearchKey(value)
        fetchDataList({
            "page": datatable_state.page + 1,
            "search": value
        })
    }

    function triggerAction(data = '', action = '', status = ''){
        let ids = [];
        if(action === 'single-delete'){
            ids.push(data.id)
        }
        else{
            ids = data.map(o => o['id']);
        }

        let title = 'Delete Record'
        if(ids.length > 1){
            title = 'Delete Records'
        }

        Swal.fire({
            title: title,
            text: 'This action cannot be reversed. All associated records will also be deleted. Do you want to continue?',
            showCancelButton: true,
            showConfirmButton: false,
            closeOnCancel: true,
            showDenyButton: true,
            denyButtonText: 'Yes'
        })
        .then((result) => {
            if (result.isDenied) {
                deleteItem(ids)
            }
        })
    }

    function deleteItem(ids){
        const url = helpers.createUrl('V1/cashflow/categories/delete')
        httpRequest(url, 'POST', {
            postdata: {
                "ids": ids,
            },
        }, true)
            .then((res) => {
                setLoading(0)
                fetchDataList()
                setSelectedItems([])

                Swal.fire({
                    title: "Success",
                    text: res.message,
                    icon: "success",
                    confirmButtonText: "OK",
                })
            })
            .catch((err) => {
                console.log(err)
                setLoading(0)
                setSelectedItems([])

                Swal.fire({
                    text: err.message,
                    //text: err.message,
                    icon: "error",
                    confirmButtonText: "OK",
                })
            }); 
    }

    function displayDataTable(data){
        setDataTable(
            <DataTable 
                className='border-top'
                dataKey={data.id}
                value={data.data} 
                // tableStyle={{ minWidth: '50rem' }}
                size="normal"
                paginator 
                rows={data.per_page} 
                rowsPerPageOptions={[5, 10, 20, 25, 50]}
                totalRecords={data.total}
                onPage={onPage}
                first={datatable_state.first}
                lazy
                currentPageReportTemplate="{first} to {last} of {totalRecords}"
                selection={selected_items} 
                onSelectionChange={onSelectItem}
                scrollHeight="600px"
                scrollable
                responsive={true}
                emptyMessage="No data to display"
            >
                <Column selectionMode="multiple" headerStyle={{ width: '3rem' }} />
                <Column field="name" header="NAME" ></Column>
                <Column 
                    header="TYPE" 
                    style={{ maxWidth: '50px' }} 
                    body={({type}) => type === 'income' ? 
                        <span className={`text-center rounded px-2 py-1 text-white text-sm bg-success ml-2`}>{helpers.ucwords(type)}</span> : 
                        <span className={`text-center rounded px-2 py-1 text-white text-sm bg-danger ml-2`}>{helpers.ucwords(type)}</span> }>
                    
                </Column>
                <Column className="text-right" body={displayActionMenu} style={{ maxWidth: '100px' }}></Column> 
            </DataTable>
        )

    }

    const onPage = (e) => {
        setDataTableState(e)
        setSelectedItems([])
    };

    const onSelectItem = (e) => {
        const value = e.value;
        setSelectedItems(value);
    };

    function displayActionMenu(data){
        return (<Dropdown>
                        <Dropdown.Toggle className='btn-light border' size="sm" id={"dropdown-actions-"+data.id}>Action</Dropdown.Toggle>
                        <Dropdown.Menu align="end">
                            <Dropdown.Item 
                                key="edit" 
                                onClick={(e) => editForm(data.id)}
                                className={helpers.checkPermissions(['superAdmin', 'cashFlowCategoryEdit'], account?.permissions) ? 'text-dark' : 'secondary'}
                                disabled={!helpers.checkPermissions(['superAdmin', 'cashFlowCategoryEdit'], account?.permissions)}
                            ><i className="fas fa-pencil-alt mr-2" />Edit</Dropdown.Item>
                            <Dropdown.Divider />
                            <Dropdown.Item 
                                key="delete" 
                                className={helpers.checkPermissions(['superAdmin', 'cashFlowCategoryDelete'], account?.permissions) ? 'text-danger' : 'text-secondary'}
                                disabled={!helpers.checkPermissions(['superAdmin', 'cashFlowCategoryDelete'], account?.permissions)}
                                onClick={(e) => triggerAction(data, 'single-delete')}
                            ><i className="fas fa-trash mr-2" />Delete</Dropdown.Item>
                        </Dropdown.Menu>
                    </Dropdown>)
    }
    
    function addForm(e){
        setReferenceID('')
        setShowModal(1)
    }
    function editForm(id){
        setShowModal(1)
        setReferenceID(id)
    }

    function handleSave(){
        fetchDataList()
    }

    return (
        <>
            <Toast ref={toast} position="top-right" />
            <CashFlowCategoryForm 
                showModal={show_modal} 
                closeModal={setShowModal} 
                handleSave={handleSave}
                reference_id={reference_id}
            />
            <Layout page_title={page_title} menu={menu} parent_text='Cash Flow'>
            <div className="container-fluid" style={{position: 'relative'}}>
                <Loader isLoading={loading}/>
                <div className="row">
                    <div className="col-12">
                        <div className="card">
                            <div className="card-header border-bottom-0">
                                <div className="row">
                                    <div className="col-lg-7">
                                        <div className='d-flex flex-column flex-md-row'>
                                            <SelectButton 
                                                name='type' 
                                                value={category_type}
                                                onChange={(e) => setCategoryType(e.value)}
                                                options={[
                                                    // {"value":"all","label": "All"},
                                                    {"value":"expense","label": "Expense"},
                                                    {"value":"income","label": "Income"},
                                                ]}
                                                optionLabel="label"
                                                optionValue="value"
                                                allowEmpty={false}
                                            />
                                            <InputText 
                                                placeholder="Search Category"
                                                onChange={search} 
                                                value={search_key}
                                                className='ml-0 ml-md-3 mt-3 mt-md-0'
                                            />
                                        </div>
                                    </div>
                                    <div className="col-lg-5 text-right mt-3 mt-md-0">
                                        <button type='button' className='btn btn-primary float-right' onClick={addForm} disabled={!helpers.checkPermissions(['superAdmin', 'cashFlowCategoryCreate'], account?.permissions)}><i className="fas fa-plus-circle mr-2" />New</button>


                                        <Button 
                                            className='btn btn-outline-secondary mr-3'
                                            style={{ borderRadius: '8px', boxShadow: '0 2px 5px rgba(0,0,0,0.1)' }}
                                            onClick={(event) => menuRight.current.toggle(event)} 
                                            aria-controls="popup_menu_right"
                                            aria-haspopup
                                        ><BsThreeDotsVertical /></Button> 
                                        <Menu 
                                            model={action_items} 
                                            popup ref={menuRight} 
                                            id="popup_menu_right" 
                                            popupAlignment={menuAlignment}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="card-body p-0">
                                { data_table }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Layout>
        </>
    )
}